// extracted by mini-css-extract-plugin
export default {"label":"label_dmTlGZX","label_bold":"label_bold_P70diHz","tooltipBtn":"tooltipBtn_MzqHFNV"};